import { ApplicationState, AppThunkDispatch } from '../../store';
import NavMenu, { NavMenuStateProps, NavMenuDispatchProps } from './NavMenu';
import { connect } from 'react-redux';
import { loadBaseData, logout } from '../../store/session/actions';

const mapStateToProps = (state: ApplicationState): NavMenuStateProps => ({
    user: state.session.user,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): NavMenuDispatchProps => ({
    logout: () => dispatch(logout()),
    homeClick: () => {
        dispatch(loadBaseData())
    },
});

export default connect<NavMenuStateProps, NavMenuDispatchProps, void, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(NavMenu as any);
